module.exports = __webpack_public_path__ + "assets/images/icons/alone.svg?v=cd774c04";